import React, { useEffect } from "react";
import { connect } from "react-redux";

import GridItem from "../../components/UI/Grid/GridItem";
import GridContainer from "../../components/UI/Grid/GridContainer";
import FootballCard from "../../components/UI/Card/Card";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../axios/axios-football";
import * as actions from "../../store/actions/index";
import Spinner from "../../components/UI/Spinner/Spinner";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import  './Countries.module.css';
const Countries = props => {
  const { onFetchCountries, onSelectedCountry } = props;
  useEffect(() => {
    // done to not do api call if countries are saved in the state as they dont change
    if (props.countries.length === 0) {
      onFetchCountries();
    }
  }, [onFetchCountries]);

  const redirectToCountryView = countryName => {
    onSelectedCountry(countryName);
    props.history.push("/country");
  };

  let countries = <Spinner />;
  if (!props.loading) {
    countries = props.countries.map((country, i) => (
      <CSSTransition key={i} classNames="example" timeout={{ enter: 500, exit: 300 }}>
      <GridItem xs={12} sm={6} md={4} key={country.country}>
        <FootballCard
          alt={country.country}
          src={
            country.flag
              ? country.flag
              : "https://media.api-football.com/flags/ad.svg"
          }
          title={country.country}
          onClick={() => {
            redirectToCountryView(country.country);
          }}
        />
        <br />
      </GridItem>
      </CSSTransition>
    ));
  }

  return (
    <GridContainer>{countries}</GridContainer>
  );
};
const mapStateToProps = state => {
  return {
    countries: state.football.countries,
    loading: state.football.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchCountries: () => dispatch(actions.fetchCountries()),
    onSelectedCountry: country => dispatch(actions.selectCountry(country))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Countries, axios));
